import { ReactNode, useContext } from 'react';

import errors from '../constants/errors';
import { nortadaLogger } from '../components/common/logger';
import { BusinessError } from '../components/common/business-error';
import { ToastNotificationContext } from '../components/common/toast-notification';

export const useHandleApiError = () => {
  const { openToast } = useContext(ToastNotificationContext);

  return <T extends string>({
    message,
    errorMapper,
    handleBusinessError = errorMessage => {
      openToast({
        message: errorMessage,
        severity: 'error',
        closeOnClickOnly: true
      });
    },
    handleNonBusinessError = errorMessage => {
      openToast({
        message: errorMessage,
        severity: 'error',
        closeOnClickOnly: true
      });
    }
  }: {
    message: T;
    errorMapper?: (message: T) => BusinessError | null;
    handleBusinessError?: (error: ReactNode | string) => void;
    handleNonBusinessError?: (error: ReactNode | string) => void;
  }) => {
    const businessError = errorMapper?.(message);

    if (businessError) {
      handleBusinessError?.(businessError.message);
    } else {
      handleNonBusinessError(errors.somethingWentWrong);
    }
    nortadaLogger.error(message);
  };
};
